import useSWR from 'swr'
import { endpoints, request } from '.'

export const useSiteConfig = () => {
  const { data, isLoading, isValidating, error } = useSWR(
    endpoints.dataAccount.get(),
    request
  )
  return {
    siteConfig: data?.data?.data?.attributes?.site?.config,
    isLoading,
    isValidating,
    error,
  }
}
